/** Thai and English text for Boards (apps/boards): boards shared as a whole, columns of cards, cards given to people */
export const th = {
  app: {
    name: 'Boards',
    description: 'ติดตามงานโปรเจกต์ของออฟฟิศเป็นบอร์ด คอลัมน์ และการ์ด แชร์บอร์ดให้คน สาขา แผนก หรือทั้งบริษัท',
  },
  nav: { boards: 'บอร์ดทั้งหมด', mine: 'การ์ดของฉัน', archive: 'เก็บถาวร' },
  roles: { owner: 'เจ้าของ', viewer: 'ผู้ดู', member: 'สมาชิก' },
  rolesHint: {
    viewer: 'เห็นบอร์ด การ์ด และความคิดเห็น และแสดงความคิดเห็นได้ แก้การ์ดไม่ได้',
    member: 'ทำได้แบบผู้ดู และสร้าง แก้ ย้าย เก็บการ์ด และเพิ่มหรือแก้คอลัมน์',
  },
  colors: {
    violet: 'ม่วง',
    blue: 'น้ำเงิน',
    teal: 'เขียวน้ำทะเล',
    green: 'เขียว',
    amber: 'เหลือง',
    orange: 'ส้ม',
    red: 'แดง',
    pink: 'ชมพู',
    grey: 'เทา',
  },
  /** A new board's columns */
  starter: { todo: 'ต้องทำ', doing: 'กำลังทำ', done: 'เสร็จแล้ว' },
  due: { over: 'เลยกำหนด', today: 'วันนี้', soon: '7 วันข้างหน้า', later: 'ภายหลัง', none: 'ไม่มีกำหนด', done: 'เสร็จแล้ว' },
  list: {
    mine: 'บอร์ดของฉัน',
    shared: 'แชร์กับฉัน',
    empty: 'ยังไม่มีบอร์ด สร้างบอร์ดแรกของโปรเจกต์ได้เลย',
    sharedEmpty: 'ยังไม่มีใครแชร์บอร์ดให้คุณ',
    cards: 'การ์ด {{count}}',
    mineOpen: 'ของคุณที่ยังไม่เสร็จ {{count}}',
    onlyYou: 'เฉพาะคุณ',
    sharedWith: 'แชร์กับ{{names}}',
    and: ' และ',
    ownedBy: 'ของ{{name}}',
    via: 'แชร์ให้{{kind}}{{name}}',
    viaYou: 'แชร์ให้คุณ',
  },
  actions: {
    newBoard: 'บอร์ดใหม่',
    addCard: 'เพิ่มการ์ด',
    addColumn: 'เพิ่มคอลัมน์',
    share: 'แชร์บอร์ด',
    star: 'ติดดาว',
    unstar: 'เอาดาวออก',
    edit: 'แก้ชื่อและสี',
    archive: 'เก็บถาวร',
    restore: 'นำกลับ',
    delete: 'ลบถาวร',
    follow: 'ติดตาม',
    following: 'ติดตามอยู่',
    copyLink: 'คัดลอกลิงก์การ์ด',
    copied: 'คัดลอกแล้ว วางในแชทได้เลย',
    rename: 'เปลี่ยนชื่อ',
    countsDone: 'นับเป็นงานเสร็จ',
    moveLeft: 'ย้ายไปทางซ้าย',
    moveRight: 'ย้ายไปทางขวา',
    deleteColumn: 'ลบคอลัมน์',
    addItem: 'เพิ่มรายการ',
    attach: 'แนบไฟล์',
    send: 'ส่ง',
    onlyMine: 'เฉพาะการ์ดของฉัน',
    more: 'ทำอะไรกับ{{name}}',
    newLabel: 'ป้ายใหม่',
    openBoard: 'เปิดบอร์ด',
  },
  board: {
    you: 'คุณเป็น{{role}}',
    viewerHint: 'คุณเป็นผู้ดู: เปิดการ์ดและแสดงความคิดเห็นได้ ย้ายหรือแก้ไม่ได้',
    dragHint: 'ลากการ์ดเพื่อย้าย · กดการ์ดเพื่อเปิด',
    phoneHint: 'ปัดซ้ายขวาเพื่อเปลี่ยนคอลัมน์ · กดค้างที่การ์ดเพื่อลาก',
    cardName: 'ชื่อการ์ด',
    cardNamePlaceholder: 'งานที่ต้องทำ เช่น ขอใบเสนอราคาเครื่องพิมพ์',
    newCard: 'การ์ดใหม่',
    newColumn: 'คอลัมน์ใหม่',
    editColumn: 'แก้ไขคอลัมน์',
    doneHint: 'การ์ดในคอลัมน์นี้ถือว่าเสร็จแล้ว ไม่ขึ้นในการ์ดของฉัน และไม่เตือนวันครบกำหนด',
    addAndNext: 'เพิ่มแล้วสร้างต่อ',
    added: 'เพิ่มการ์ดแล้ว',
    columnName: 'ชื่อคอลัมน์',
    emptyColumn: 'ยังไม่มีการ์ด',
    doneColumn: 'การ์ดในคอลัมน์นี้นับเป็นงานเสร็จ',
    columnHasCards: 'ย้ายหรือเก็บการ์ดในคอลัมน์นี้ก่อนจึงลบได้',
    notFound: 'ไม่พบบอร์ดนี้ หรือไม่ได้แชร์ให้คุณ',
  },
  card: {
    assignees: 'ผู้รับผิดชอบ',
    addAssignee: 'เพิ่มผู้รับผิดชอบ',
    due: 'วันครบกำหนด',
    labels: 'ป้าย',
    description: 'รายละเอียด',
    descriptionPlaceholder: 'เพิ่มรายละเอียดของงานนี้',
    checklist: 'เช็กลิสต์',
    checkPlaceholder: 'รายการ กด Enter เพื่อเพิ่ม',
    files: 'ไฟล์แนบ',
    activity: 'ความคิดเห็นและความเคลื่อนไหว',
    comment: 'เขียนความคิดเห็น พิมพ์ @ เพื่อเรียกคน',
    none: 'ยังไม่มี',
    noDue: 'ไม่มีกำหนด',
    column: 'คอลัมน์',
    archived: 'การ์ดนี้เก็บถาวรแล้ว นำกลับได้จากเก็บถาวร',
    followHint: 'ได้รับแจ้งเมื่อมีความคิดเห็นใหม่',
    created: 'สร้างโดย {{name}} · {{date}}',
    notFound: 'ไม่พบการ์ดนี้ หรือไม่ได้แชร์ให้คุณ',
    edited: 'แก้ไขแล้ว',
    showAll: 'ทั้งหมด',
    showComments: 'ความคิดเห็น',
    noActivity: 'ยังไม่มีความคิดเห็น เริ่มคุยเรื่องงานนี้ได้เลย',
    restoreHint: 'นำกลับเพื่อแก้ไข',
  },
  mine: {
    title: 'การ์ดของฉัน',
    hint: 'การ์ดที่มอบหมายให้คุณในทุกบอร์ด ที่ยังไม่อยู่ในคอลัมน์งานเสร็จ เรียงตามวันครบกำหนด',
    empty: 'ไม่มีการ์ดที่รอคุณ',
    all: 'ดูทั้งหมด ({{count}})',
  },
  archive: {
    title: 'เก็บถาวร',
    hint: 'บอร์ดและการ์ดที่เก็บไว้ไม่แสดงบนบอร์ด นำกลับได้ตลอด ลบถาวรได้เฉพาะเจ้าของบอร์ด',
    boards: 'บอร์ด',
    cards: 'การ์ด',
    empty: 'ยังไม่มีอะไรที่เก็บไว้',
    where: '{{board}} · เคยอยู่ใน {{column}}',
    confirmDelete: 'ลบ “{{name}}” ถาวร?',
    confirmDeleteBody: 'ลบแล้วกู้คืนไม่ได้ รวมทุกอย่างในนั้น',
    boardArchived: 'บอร์ดนี้เก็บถาวรแล้ว นำกลับได้จากเก็บถาวร',
  },
  share: {
    title: 'แชร์ “{{name}}”',
    saved: 'บันทึกการแชร์แล้ว',
    follows: 'ทุกการ์ดในบอร์ดใช้สิทธิ์เหล่านี้ มอบหมายการ์ดได้เฉพาะคนที่เห็นบอร์ด',
  },
  form: {
    newTitle: 'บอร์ดใหม่',
    editTitle: 'แก้ชื่อและสีของบอร์ด',
    name: 'ชื่อบอร์ด',
    namePlaceholder: 'เช่น เปิดสาขาเชียงราย',
    color: 'สี',
    starts: 'เริ่มด้วยคอลัมน์ {{columns}} เปลี่ยนชื่อหรือเพิ่มคอลัมน์ทีหลังได้',
  },
  /** The search box's (⌘K) groups */
  search: { boards: 'บอร์ด', cards: 'การ์ด' },
  saved: 'บันทึกแล้ว',
} as const

export const en = {
  app: {
    name: 'Boards',
    description: "Track the office's projects as boards, columns and cards, shared with people, branches, departments or the whole company",
  },
  nav: { boards: 'All boards', mine: 'My cards', archive: 'Archive' },
  roles: { owner: 'Owner', viewer: 'Viewer', member: 'Member' },
  rolesHint: {
    viewer: 'Sees the board, its cards and comments, and comments too; can’t change cards',
    member: 'As a viewer, and makes, changes, moves and archives cards, and adds or changes columns',
  },
  colors: {
    violet: 'Violet',
    blue: 'Blue',
    teal: 'Teal',
    green: 'Green',
    amber: 'Amber',
    orange: 'Orange',
    red: 'Red',
    pink: 'Pink',
    grey: 'Grey',
  },
  starter: { todo: 'To do', doing: 'Doing', done: 'Done' },
  due: { over: 'Overdue', today: 'Today', soon: 'Next 7 days', later: 'Later', none: 'No due date', done: 'Done' },
  list: {
    mine: 'My boards',
    shared: 'Shared with me',
    empty: 'No boards yet. Make the first one for a project',
    sharedEmpty: 'Nobody has shared a board with you yet',
    cards: '{{count}} cards',
    mineOpen: '{{count}} of yours to do',
    onlyYou: 'Only you',
    sharedWith: 'Shared with {{names}}',
    and: ' and ',
    ownedBy: "{{name}}'s",
    via: 'Shared with {{kind}} {{name}}',
    viaYou: 'Shared with you',
  },
  actions: {
    newBoard: 'New board',
    addCard: 'Add a card',
    addColumn: 'Add a column',
    share: 'Share board',
    star: 'Star',
    unstar: 'Unstar',
    edit: 'Name and colour',
    archive: 'Archive',
    restore: 'Restore',
    delete: 'Delete for good',
    follow: 'Follow',
    following: 'Following',
    copyLink: 'Copy the card’s link',
    copied: 'Copied: paste it in a chat',
    rename: 'Rename',
    countsDone: 'Counts as done',
    moveLeft: 'Move left',
    moveRight: 'Move right',
    deleteColumn: 'Delete column',
    addItem: 'Add an item',
    attach: 'Attach a file',
    send: 'Send',
    onlyMine: 'Only my cards',
    more: 'More for {{name}}',
    newLabel: 'New label',
    openBoard: 'Open board',
  },
  board: {
    you: 'You are a {{role}}',
    viewerHint: 'You are a viewer: open cards and comment, but not move or change them',
    dragHint: 'Drag a card to move it · click a card to open it',
    phoneHint: 'Swipe sideways for another column · press and hold a card to drag it',
    cardName: 'Card name',
    cardNamePlaceholder: 'What needs doing, e.g. get quotes for printers',
    newCard: 'New card',
    newColumn: 'New column',
    editColumn: 'Edit column',
    doneHint: 'Cards in this column are done: off My cards and never reminded of',
    addAndNext: 'Add and make another',
    added: 'Card added',
    columnName: 'Column name',
    emptyColumn: 'No cards yet',
    doneColumn: 'Cards in this column count as done',
    columnHasCards: 'Move or archive the cards in this column first',
    notFound: 'This board isn’t there, or isn’t shared with you',
  },
  card: {
    assignees: 'Assignees',
    addAssignee: 'Add an assignee',
    due: 'Due date',
    labels: 'Labels',
    description: 'Description',
    descriptionPlaceholder: 'Add a description of this work',
    checklist: 'Checklist',
    checkPlaceholder: 'An item, Enter to add',
    files: 'Attachments',
    activity: 'Comments and activity',
    comment: 'Write a comment, type @ to mention someone',
    none: 'None yet',
    noDue: 'No due date',
    column: 'Column',
    archived: 'This card is archived. Restore it from the archive',
    followHint: 'Be told of new comments',
    created: 'Made by {{name}} · {{date}}',
    notFound: 'This card isn’t there, or isn’t shared with you',
    edited: 'edited',
    showAll: 'All',
    showComments: 'Comments',
    noActivity: 'No comments yet. Start talking about this work',
    restoreHint: 'Restore it to change it',
  },
  mine: {
    title: 'My cards',
    hint: 'Cards given to you on every board, not yet in a done column, by due date',
    empty: 'Nothing waits for you',
    all: 'See all ({{count}})',
  },
  archive: {
    title: 'Archive',
    hint: 'Archived boards and cards don’t show on boards. Restore them any time; only a board’s owner deletes for good',
    boards: 'Boards',
    cards: 'Cards',
    empty: 'Nothing archived yet',
    where: '{{board}} · was in {{column}}',
    confirmDelete: 'Delete “{{name}}” for good?',
    confirmDeleteBody: 'It can’t be restored, nor anything in it',
    boardArchived: 'This board is archived. Restore it from the archive',
  },
  share: {
    title: 'Share “{{name}}”',
    saved: 'Sharing saved',
    follows: 'Every card on the board follows these. Cards can be given only to people who see the board',
  },
  form: {
    newTitle: 'New board',
    editTitle: 'Board name and colour',
    name: 'Board name',
    namePlaceholder: 'e.g. Opening the Chiang Rai branch',
    color: 'Colour',
    starts: 'Starts with the columns {{columns}}; rename or add columns later',
  },
  search: { boards: 'Boards', cards: 'Cards' },
  saved: 'Saved',
} as const
